module.exports = __webpack_public_path__ + "img/logo_wyp.f7a756f9.jpg";